import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {MatLegacyButtonModule as MatButtonModule} from '@angular/material/legacy-button';
import {MatLegacyDialogModule as MatDialogModule} from '@angular/material/legacy-dialog';
import {MatDividerModule} from '@angular/material/divider';
import {MatStepperModule} from '@angular/material/stepper';
import {LetModule, PushModule} from '@ngrx/component';
import {StripePaymentSelectionService} from '@spout/global-web/data-access';
import {SptMySubscriptionModule} from '@spout/global-web/ui';
import {PageSubscribeRoutingModule} from './page-subscribe-routing.module';
import {PageSubscribeComponent} from './page-subscribe.component';
import {PaymentWizardSmallModule} from './payment-wizard-small/payment-wizard-small.module';
import {PaymentWizardWideModule} from './payment-wizard-wide/payment-wizard-wide.module';

@NgModule({
  imports: [
    CommonModule,
    PageSubscribeRoutingModule,

    LetModule,
    PushModule,

    MatButtonModule,
    MatDialogModule,
    MatDividerModule,
    MatStepperModule,

    PaymentWizardSmallModule,
    PaymentWizardWideModule,
    SptMySubscriptionModule
  ],
  declarations: [PageSubscribeComponent],
  exports: [PageSubscribeComponent],
  providers: [StripePaymentSelectionService]
})
export class PageSubscribeModule {}
